export const CLOSE_BUTTON_TEST_ID = 'droneDetailsDrawerHeaderCloseButton';

export const TEST_ID = 'droneDetailsDrawerHeader';
